import type { BorderRadius, CardStyle, FontFamily } from '@/types/theme';

export const themeRadii: Record<BorderRadius, string> = { none: '0', sm: '4px', md: '8px', lg: '12px', xl: '16px' };
export const themeFonts: Record<FontFamily, string> = {
  inter: 'var(--font-inter), system-ui, sans-serif',
  geist: 'var(--font-geist-sans), system-ui, sans-serif',
  system: 'system-ui, sans-serif',
};
export const themeCardShadows: Record<CardStyle, string> = {
  flat: 'none',
  raised: '0 10px 15px -3px rgb(0 0 0 / 0.08), 0 4px 6px -4px rgb(0 0 0 / 0.04)',
  bordered: '0 1px 3px 0 rgb(0 0 0 / 0.04), 0 1px 2px -1px rgb(0 0 0 / 0.04)',
};
